import { createHttpClient } from "./http";

export class ProcessoRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async getAll(unidadeDistribuidoraId) {
		try {
			const result = await this.axios.get("processo-unidade-distribuidora", {
				params: { unidadeDistribuidoraId },
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401)
				throw new Error("Usuário não autenticado.");

			throw new Error(error.response?.data?.message || "Erro ao listar processos.");
		}
	}
}
